import { CSSProperties, ReactNode } from "react";
import { ContextTabs } from "@/zapi-frontend/pages/ProjectDetailsPage/ui/ProjectLayout/ui/blocks/ContextTabs";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import type { TSectionPage } from "../model/types";

// The tab row plus the 8px band of page color that keeps pinned card headers off the tabs.
const SECTION_TABS_HEIGHT = "3.25rem";

export const SECTION_STICKY_GAP = "1rem";

export const sectionStickyTop = (hasTabs: boolean) =>
  `calc(var(--app-header-height) + ${hasTabs ? SECTION_TABS_HEIGHT : SECTION_STICKY_GAP})`;

type TSectionPageProps = {
  page: TSectionPage;
  fill?: boolean;
  children: ReactNode;
};

export function SectionPage({ page, fill, children }: TSectionPageProps) {
  const hasTabs = page.tabs.length > 0;
  return (
    <div
      data-testid="section-page"
      style={hasTabs ? undefined : ({ "--widget-sticky-gap": SECTION_STICKY_GAP } as CSSProperties)}
      className="w-full min-w-0"
    >
      <section
        className={cn(
          "mx-auto flex w-full max-w-[960px] flex-col",
          fill ? "h-[calc(100svh-var(--app-header-height)-1rem)] min-h-0 pb-3" : "pb-8"
        )}
      >
        <h1 className={cn("typo-h3 min-h-10 shrink-0 text-foreground", hasTabs ? "mb-2" : "mb-6")}>{page.title}</h1>
        {hasTabs && (
          <ContextTabs
            tabs={page.tabs}
            value={page.activeTabId}
            onValueChange={page.onTabChange}
            sticky
            className="shrink-0"
          />
        )}
        <div className={cn("flex min-w-0 flex-col", hasTabs && "pt-6", fill && "min-h-0 flex-1")}>{children}</div>
      </section>
    </div>
  );
}
